import { ButtonGroup } from '@rneui/themed';
import React, { FC } from 'react';
import type { IShaButtonGroupProps } from './interface';

const ShaButtonGroup: FC<IShaButtonGroupProps> = (props) => {
  return (
    <ButtonGroup {...props}>
      {props.children ? props.children : props.title}
    </ButtonGroup>
  );
};

export default ShaButtonGroup;
